import React from "react";

function FpgMinusIcon({width,height,color}) {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 20 20"
  >
    <circle cx="10" cy="10" r="10" fill={color}></circle>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M15 10H5"
    ></path>
  </svg>
  );
}

export default FpgMinusIcon;
